<template>
  <div>
    <div class="col-12 overflow-auto">
      <label class="mb-3 leftLabels"><i class="fe fe-message-circle mr-2"></i>{{ $t("common.edit_task.comments") }}</label>
      <input
        v-model="commentText"
        @keydown.enter="createComment"
        class="commentField p-2"
        placeholder="Add comment"
        type="text">
      <button
        @click="createComment"
        class="btn btn-outline-primary btn-sm float-right mt-3"
      >
        {{ $t("common.edit_task.send") }}
      </button>
    </div>
    <div class="col-12 mt-4">
      <div
        v-for="comment in comments"
        :class="[comment.isNew ?  'fakeComment': '']"
        :key="comment._id"
        class="row animated p-3">
        <div class="col-md-1 d-flex justify-content-center pl-0 ml-0">
          <div
            class="avatar avatar avatar-disabled"
            style="width: 2.5rem; height: 2.5rem">
            <div class="avatar avatar ml-1">

              <template v-if="getPerson(comment.created_by).picture_url">
                <img
                  :src="getPerson(comment.created_by).picture_url"
                  style="transition: 1s filter ease-out; width: 75%; height: 75%"
                  alt="..."
                  class="avatar-img rounded-circle shadow-sm">
              </template>
              <template v-else>
                <span
                  class="avatar-title mr-2 rounded-circle"
                  style="width: 75%; height: 75%;">
                  {{(getPerson(comment.created_by).first_name || '').slice(0, 1)+(getPerson(comment.created_by).last_name || '').slice(0, 1)}}
                </span>
              </template>
            </div>
          </div>
        </div>
        <div class="col-md-11">
          <h3 class="text-dark m-0 p-0 mb-2" style="word-spacing: 3px;">
            <b>{{ getPerson(comment.created_by).first_name }} {{ getPerson(comment.created_by).last_name }}</b>
            <span class="float-right"> {{ comment.created_at | fromNow }}</span>
          </h3>
          <span class="text-muted comment-text">{{ comment.text }}</span>
          <i
            @click="deleteComment(comment._id)"
            :style="{'cursor': comment.isNew ? 'not-allowed' : 'pointer'}"
            class="fe fe-trash-2 icons animated showIcon float-right pr-2"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { fromNowFilterMixin } from '@/mixins/fromNowFilterMixin';
  const moment = require('moment');

  export default {
    name: 'EditTaskComments',
    data () {
      return {
        comments: [],
        commentText: '',
      };
    },
    mixins: [fromNowFilterMixin],
    props: {
      taskId: {
        default: '',
      },
    },
    computed: {
      ...mapGetters([
        'members',
        'account',
      ]),
    },
    sockets: {
      update_task: function () {
        this.getComments(this.taskId);
      },
    },
    watch: {
      taskId: function (newTaskId) {
        this.getComments(newTaskId);
      },
    },
    methods: {
      getComments (id) {
        this.loading = true;
        this.$api().get(`tasks/${id}/info?token=${localStorage.getItem('token')}`)
          .then(response => {
            this.comments = response.data.payload.comments;
            // this.subtasks = response.data.payload.sub_tasks.sort((a, b) => (a.order - b.order));
            // this.loading = false;
          });
      },
      createComment () {
        if (!this.commentText) {
          return false;
        }
        const fakeId = Date.now() + '';
        const fuckingFakeComment = {
          _id: fakeId,
          created_at: moment(),
          text: this.commentText,
          created_by: this.account._id,
          isNew: true,
        };
        this.comments.push(fuckingFakeComment);

        this.$api().post(`tasks/${this.taskId}/comment`, { text: this.commentText }, {
          params: { token: localStorage.getItem('token') },
        })
          .then(response => {
            if (response.data.ok) {
              for (const comment of this.comments) {
                if (comment._id === fakeId) {
                  comment._id = response.data.payload._id;
                  comment.isNew = false;
                  break;
                }
              }
            } else {
              this.$app.$noty.error('An Error occurred: ' + response.data.error);
            }
          });

        setTimeout(() => {
          this.commentText = '';
        }, 0);
      },
      deleteComment (commentId) {
        this.$api().post(`tasks/${this.taskId}/comments/${commentId}/delete`, {}, {
          params: { token: localStorage.getItem('token') },
        })
          .then(response => {
            if (response.data.ok) {
              this.getComments(this.taskId);
            } else {
              this.$app.$noty.error('An Error occurred: ' + response.data.error);
            }
          });
      },
      getPerson (personId) {
        return this.members.find(user => user._id === personId, 1) || {};
      },
    },
    mounted () {
      this.getComments(this.taskId);
    },
  };
</script>

<style scoped>
  h3 {
    font-size: 14px;
  }
  .comment-text {
    font-size: 13px;
  }
  .commentField {
    font-size: 13px;
    color: #6F85A2;
    display: block;
    width: 100%;
    border: 1px solid #96ABC8;
    box-sizing: border-box;
    border-radius: 6px;
  }

  .commentField::placeholder {
    color: #6F85A2;
  }
  .commentField::-webkit-input-placeholder {
    color: #6F85A2;
  }
  .commentField:-ms-input-placeholder {
    color: #6F85A2;
  }

  .fakeComment {
    opacity: 0.6;
  }

  .showIcon {
    color: #E43A5A;
    opacity: 0;
  }

  .animated {
    border-radius: 6px;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -ms-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }

  .animated:hover {
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -ms-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
    background-color: #F8F9FC;
  }

  .animated:hover .showIcon {
    opacity: 1;
  }
</style>
